import ZellePage from "components/pages/ZellePage"

/**
 * @name BID126ZellePage
 * @function
 * @extends React.Component
 * @exported true
 * @description A transfers page component only for bid 126. 
 * This was build because that bid has multiple routes in different
 * nav items that go to the same page, which exposed a bug in the "NavItem" component.
 * There is a bug in "NavItem" where the same routes on different
 * nav items would select all of those different nav items.
 * @example
 * export default function Component() {
 *  return (
 *      <div>
 *          <BID126ZellePage/>
 *      </div>
 *  );
 * }
 */
export default function BID126ZellePage(props) {
  return (
    <ZellePage />
  );
}
